var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCurvedArrow = function SvgCurvedArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.302 2.326c.269-.543.803-.267 1.07-.166 1.07.434 1.96 1.63 2.407 2.174 1.605 2.173 2.407 4.293 2.407 8.422s-2.585 6.765-3.477 7.49c.357.09 2.285-.165 2.942 0 1.07.267.992.88.803 1.07-.268.267-1.071.487-1.872.535-2.107.126-1.338.143-3.21.143-1.284 0-1.872.14-1.872-.946v-3.944c0-.816.268-1.405 1.07-1.137.609.202.535 1.861.535 2.223v.718c2.14-1.07 3.263-2.946 3.477-6.423.267-4.347-.805-5.846-1.605-7.064s-1.353-1.76-2.14-2.292c-.267-.181-.67-.528-.535-.802Z"
  })));
};
export { SvgCurvedArrow as ReactComponent };
export default __webpack_public_path__ + "static/media/curvedArrow.f76b3a57959a45dca3c2a5b895c73c63.svg";